import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaSearch,
  FaPhoneAlt,
  FaChevronDown,
  FaChevronUp,
  FaBars,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import OrderWithCartsPopup from "../OrderPopUp/OrderWithCartsPopup";
// import Logo from "../Assets/logo-02.jpeg";
import Logo from "../Assets/fab hub logo (tm).png";
import { ShopContext } from "../../Context/ShopContext";
import { MdOutlineShoppingCart, MdClose, MdDelete } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { LuUserRound } from "react-icons/lu";
import "react-toastify/dist/ReactToastify.css";
import { currency } from "../../App";
import Dropdown from "../Navbar/DropDown";
import { toast } from "react-toastify";

import { menuItems } from "../../Constants/menuItems";

const Search = ({ setSearchResults }) => {
  const {
    products,
    addToCart,
    cartItems,
    removeFromCart,
    getTotalCartItems,
    deleteFromCart,
    getTotalCartAmount,
  } = useContext(ShopContext);
  const [open, setOpen] = useState(false);
  // const [toggleOpen, settoggleOpen] = useState(false);
  const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const location = useLocation();
  const [orderPopupOpen, setOrderPopupOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const cartRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const forceUpdate = useState()[1];
  const isAuthorize = !!localStorage.getItem("auth-token");
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [openSubDropdowns, setOpenSubDropdowns] = useState({});

  const toggleSubDropdown = (parentIndex, subIndex) => {
    setOpenSubDropdowns((prev) => ({
      ...prev,
      [parentIndex]: {
        ...prev[parentIndex],
        [subIndex]: !prev[parentIndex]?.[subIndex],
      },
    }));
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
  const toggleMobileDropdown = (index) => {
    setOpenMobileDropdown((prev) => (prev === index ? null : index));
  };

  const handleItemClick = (item) => {
    if (!item.dropdown && !item.subDropdown) {
      handleMouseLeave();
    }
  };

  const handleMouseEnter = (index) => setOpenMenu(index);
  const handleMouseLeave = () => setOpenMenu(null);
  const [showPopup, setShowPopup] = useState(false);

  const handlePopupNow = () => {
    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      return;
    }
    setShowPopup(true);
  };

  const closePopup = () => setShowPopup(false);
  // Filter products based on search input
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowResults(false);
        setIsDesktopDropdownOpen(false);
        setIsMobileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle search logic
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() !== "") {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(filtered);
      setSearchResults(filtered);
    } else {
      setFilteredProducts([]);
      setSearchResults([]);
    }
  };

  const handleCategorySelect = (category, source) => {
    if (source === "mobile") {
      setIsMobileDropdownOpen(false);
    } else {
      setIsDesktopDropdownOpen(false);
    }
    setSelectedCategory(category);

    let baseList = [...products];
    let filteredCategory = [];

    const bestSellerCategories = [
      "Fabrics",
      "Sarees",
      "Unique Costumes",
      "Customized Fabrics",
      "Aavriyaa's Exclusive",
      "Vintage Collection",
    ];

    if (bestSellerCategories.includes(category)) {
      // 🔥 Now filters both category AND bestseller
      filteredCategory = baseList.filter(
        (product) =>
          product.category.toLowerCase() === category.toLowerCase() &&
          product.bestseller.toLowerCase() === "yes"
      );
      setIsMobileDropdownOpen(false);
      if (filteredCategory.length === 0) {
        toast.error(`No best sellers found in "${category}"`);
      }
    } else {
      filteredCategory = baseList.filter(
        (product) => product.category.toLowerCase() === category.toLowerCase()
      );
      setIsMobileDropdownOpen(false);
    }

    // Apply search filter
    if (searchQuery.trim() !== "") {
      const filtered = filteredCategory.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
      setSearchResults(filtered);
    } else {
      setFilteredProducts(filteredCategory);
      setSearchResults(filteredCategory);
    }
  };

  return (
    <>
      <div className="">
        {/* Running Ad Section */}
        <div className="w-full bg-purple-300 text-black py-1 font-medium text-sm shadow-md flex items-center overflow-hidden">
          <div className="whitespace-nowrap overflow-hidden flex-grow ml-5">
            <p className="inline-block py-2 animate-marquee uppercase">
              🔥 Limited Time Offer! Get a massive 10% OFF on all products!
              Don't miss out—shop now! 🛍️🎉
            </p>
          </div>
        </div>

        <nav className="w-full bg-white z-10 shadow-sm px-4 md:px-8 py-2">
          {/* Top Row - Desktop */}
          <div className="hidden md:flex items-center justify-between gap-6">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/">
                <img
                  crossOrigin="anonymous"
                  src={Logo}
                  alt="Logo"
                  className="w-[110px]"
                />
              </Link>
            </div>

            {/* Search */}
            <div className="flex-1 flex justify-center">
              <div className="flex items-center border border-gray-300 rounded-md w-full max-w-2xl">
                <div className="relative" ref={dropdownRef}>
                  <button
                    className="bg-purple-300 text-black text-sm px-3 py-2 flex items-center gap-2"
                    onClick={() =>
                      setIsDesktopDropdownOpen(!isDesktopDropdownOpen)
                    }
                  >
                    <span className="pr-2 truncate max-w-[120px]">
                      {selectedCategory || "Best-Sellers"}
                    </span>
                    <IoIosArrowDown />
                  </button>
                  {isDesktopDropdownOpen && (
                    <div
                      onMouseLeave={() => setIsDesktopDropdownOpen(false)}
                      ref={dropdownRef}
                      className="absolute top-full left-0 bg-purple-300 shadow-lg border mt-1 z-50 min-w-max"
                    >
                      {[
                        "Best-Sellers",
                        "Fabrics",
                        "Sarees",
                        "Unique Costumes",
                        "Customized Fabrics",
                        "Aavriyaa's Exclusive",
                        "Vintage Collection",
                      ].map((option, index) => (
                        <p
                          key={index}
                          onClick={() => handleCategorySelect(option)}
                          className="px-4 py-2 text-sm text-black hover:bg-slate-100 cursor-pointer whitespace-nowrap"
                        >
                          {option}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
                <FaSearch className="text-gray-500 cursor-pointer mx-2" />
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  className="text-sm w-full px-2 py-2 outline-none"
                />
              </div>
            </div>

            {/* Icons */}
            <div className="flex items-center gap-5 flex-shrink-0">
              <a href="tel:+919944592904">
                <FaPhoneAlt className="text-xl text-gray-500" />
              </a>
              <Link to="/user-profile">
                <div className="relative">
                  <LuUserRound className="text-2xl" />
                  <p className="absolute -top-1 right-0 text-yellow-400 text-xl">
                    ⚡
                  </p>
                </div>
              </Link>
              <button className="relative">
                <MdOutlineShoppingCart
                  className="text-3xl text-gray-700"
                  onClick={() => setOpen(true)}
                />
                {getTotalCartItems() > 0 && (
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-0.5 rounded-full">
                    {getTotalCartItems()}
                  </span>
                )}
              </button>
            </div>
          </div>

          {/* Top Row - Mobile */}
          <div className="flex md:hidden items-center justify-between">
            <Link to="/">
              <img
                crossOrigin="anonymous"
                src={Logo}
                alt="Logo"
                className="w-[110px]"
              />
            </Link>
            <div className="flex items-center gap-3">
              <a href="tel:+919944592904">
                <FaPhoneAlt className="text-lg text-gray-500" />
              </a>
              <Link to="/user-profile">
                <div className="relative">
                  <LuUserRound className="text-xl" />
                  <p className="absolute -top-1 right-0 text-yellow-400 text-lg">
                    ⚡
                  </p>
                </div>
              </Link>
              <button className="relative" onClick={() => setOpen(true)}>
                <MdOutlineShoppingCart className="text-2xl text-gray-700" />
                {getTotalCartItems() > 0 && (
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-[10px] px-1.5 py-0.5 rounded-full">
                    {getTotalCartItems()}
                  </span>
                )}
              </button>
              {/* Hamburger */}
              <button onClick={toggleMobileMenu}>
                <FaBars className="text-2xl text-gray-700" />
              </button>
            </div>
          </div>

          {/* Search - Mobile */}
          <div className="mt-3 md:hidden">
            <div className="flex items-center border border-gray-300 rounded-md w-full">
              <div className="relative" ref={dropdownRef}>
                <button
                  className="bg-purple-300 text-black text-sm px-2 py-2 flex items-center gap-1"
                  onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
                >
                  <span className="truncate max-w-[100px]">
                    {selectedCategory || "Best-Sellers"}
                  </span>
                  <IoIosArrowDown className="text-sm" />
                </button>
                {isMobileDropdownOpen && (
                  <div className="absolute top-full left-0 bg-purple-300 shadow-lg border mt-1 z-50 min-w-max">
                    {[
                      "Best-Sellers",
                      "Fabrics",
                      "Sarees",
                      "Unique Costumes",
                      "Customized Fabrics",
                      "Aavriyaa's Exclusive",
                      "Vintage Collection",
                    ].map((option, index) => (
                      <p
                        key={index}
                        onClick={() => handleCategorySelect(option)}
                        className="px-3 py-2 text-sm text-black hover:bg-slate-100 cursor-pointer"
                      >
                        {option}
                      </p>
                    ))}
                  </div>
                )}
              </div>
              <FaSearch className="text-gray-500 cursor-pointer mx-2 text-sm" />
              <input
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                className="text-sm w-full px-2 py-2 outline-none"
              />
            </div>
          </div>

          {/* Desktop Dropdown */}
          <div className="hidden md:flex justify-center my-3">
            <ul className="flex gap-8 text-gray-700 font-medium">
              {menuItems.map((item, index) => (
                <li
                  key={index}
                  className="relative"
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <Link
                    to={item.path}
                    className="hover:text-purple-500 transition-colors flex items-center"
                  >
                    {item.label}
                    {item.dropdown && (
                      <span className="ml-1">
                        {openMenu === index ? (
                          <FaChevronUp />
                        ) : (
                          <FaChevronDown />
                        )}
                      </span>
                    )}
                  </Link>
                  {item.dropdown && openMenu === index && (
                    <Dropdown items={item.dropdown} />
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>

        {/* Off-Canvas Mobile Menu */}
        <div
          className={`fixed top-0 right-0 h-full w-72 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
            isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {/* Close button */}
          <div className="flex justify-between items-center px-4 py-3 border-b">
            <h2 className="text-lg font-semibold">Menu</h2>
            <button onClick={() => setIsMobileMenuOpen(false)}>
              <MdClose className="text-2xl text-gray-700" />
            </button>
          </div>

          {/* Menu Items */}
          <ul className="flex flex-col gap-2 px-4 py-3 text-gray-800 text-sm overflow-y-auto h-full">
            {menuItems.map((item, index) => (
              <li key={index}>
                <div
                  className="flex justify-between items-center cursor-pointer py-2"
                  onClick={() =>
                    item.dropdown
                      ? toggleMobileDropdown(index)
                      : setIsMobileMenuOpen(false)
                  }
                >
                  <Link
                    to={item.path || "#"}
                    className="block hover:text-purple-500"
                    onClick={() => !item.dropdown && setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                  {item.dropdown && (
                    <span>
                      {openMobileDropdown === index ? (
                        <FaChevronUp className="text-xs" />
                      ) : (
                        <FaChevronDown className="text-xs" />
                      )}
                    </span>
                  )}
                </div>
                {item.dropdown && openMobileDropdown === index && (
                  <ul className="pl-4 border-l border-purple-300 ml-2">
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex} className="py-1">
                        {subItem.subDropdown ? (
                          // This is a dropdown toggle
                          <div
                            className="flex justify-between items-center cursor-pointer pl-2 pr-2"
                            onClick={() => toggleSubDropdown(index, subIndex)}
                          >
                            <span className="text-sm text-gray-800 hover:text-purple-600">
                              {subItem.label}
                            </span>
                            {openSubDropdowns?.[index]?.[subIndex] ? (
                              <FaChevronUp className="text-xs" />
                            ) : (
                              <FaChevronDown className="text-xs" />
                            )}
                          </div>
                        ) : (
                          // This is a normal link
                          <Link
                            to={subItem.path || "#"}
                            className="block hover:text-purple-600 pl-2 pr-2"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {subItem.label}
                          </Link>
                        )}

                        {/* Handle subDropdown */}
                        {subItem.subDropdown &&
                          openSubDropdowns?.[index]?.[subIndex] && (
                            <ul className="ml-4 border-l border-purple-200 mt-1">
                              {subItem.subDropdown.map(
                                (nested, nestedIndex) => (
                                  <li key={nestedIndex} className="py-1">
                                    <Link
                                      to={nested.path}
                                      className="block text-sm text-gray-600 hover:text-purple-600"
                                      onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                      {nested.label}
                                    </Link>
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Overlay & Cart Section */}
        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300">
            <div
              ref={cartRef}
              className="cart-container fixed top-0 right-0 w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-2/9 z-50 bg-white h-screen border-l shadow-2xl flex flex-col"
            >
              {/* Header */}
              <div className="flex justify-between items-center px-5 py-4 border-b bg-gray-50">
                <p className="text-2xl font-semibold">Cart</p>
                <button
                  onClick={() => setOpen(false)}
                  className="text-2xl text-gray-700 hover:text-gray-900 transition"
                >
                  <MdClose />
                </button>
              </div>

              {/* Product Section (scrollable) */}
              <div className="flex-1 overflow-y-auto">
                {Object.keys(cartItems).length > 0 ? (
                  Object.keys(cartItems)
                    .filter((id) => cartItems[id] > 0)
                    .map((id) => {
                      const product = products.find(
                        (p) => p.id === parseInt(id)
                      );
                      return product ? (
                        <div
                          key={id}
                          className="justify-center items-center p-4 border-b flex gap-4"
                        >
                          {/* Product Image */}
                          <img
                            crossOrigin="anonymous"
                            className="w-24 h-24 object-cover rounded-lg border"
                            src={product.images[0]}
                            alt={product.name}
                          />

                          {/* Product Details */}
                          <div className="flex flex-col flex-1 justify-between">
                            <p className="text-lg font-semibold break-words">
                              {product.name}
                            </p>

                            <div>
                              <p className="text-gray-500">
                                {currency}
                                {(
                                  (product.old_price *
                                    (100 - product.new_price)) /
                                  100
                                ).toFixed(2)}{" "}
                                x {cartItems[id]}{" "}
                                <span className="line-through text-red-400 ml-2">
                                  {currency}
                                  {product.old_price.toFixed(2)}
                                </span>
                              </p>
                              <p className="text-gray-700 mt-1">
                                Total: {currency}
                                {(
                                  ((product.old_price *
                                    (100 - product.new_price)) /
                                    100) *
                                  cartItems[id]
                                ).toFixed(2)}
                              </p>
                            </div>
                      
                            <div className="flex justify-between items-center mt-2">
                              <div className="flex gap-2 items-center">
                                {(() => {
                                  const step =
                                    product.scale?.toLowerCase() === "meters"
                                      ? 0.5
                                      : 1;
                                  const minVal = step;
                                  return (
                                    <div className="flex items-center border border-[#dae2e6] rounded-lg overflow-hidden">
                                      <button
                                        className="px-3 py-1 border-r border-[#dae2e6]"
                                        onClick={() =>
                                          removeFromCart(
                                            Number(product.id),
                                            step
                                          )
                                        }
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        value={cartItems[product.id]}
                                        onChange={(e) => {
                                          const newVal =
                                            parseFloat(e.target.value) ||
                                            minVal;
                                          if (newVal >= minVal) {
                                            addToCart(
                                              Number(product.id),
                                              newVal
                                            ); // 👈 new helper for direct update
                                          }
                                        }}
                                        className="w-16 text-center outline-none"
                                        step={step}
                                        min={minVal}
                                      />
                                      <button
                                        className="px-3 py-1 border-l border-[#dae2e6]"
                                        onClick={() =>
                                          addToCart(Number(product.id), step)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  );
                                })()}
                              </div>

                              <button
                                className="p-1"
                                onClick={() =>
                                  deleteFromCart(Number(product.id))
                                }
                              >
                                <MdDelete className="text-lg text-red-500" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null;
                    })
                ) : (
                  <div className="text-center py-12 text-xl text-gray-500">
                    Your cart is empty!
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="flex justify-between items-center px-5 py-4 border-t">
                <p className="text-lg font-semibold">
                  Total: {currency}
                  {getTotalCartAmount()}
                </p>

                {Object.keys(cartItems).filter((id) => cartItems[id] > 0)
                  .length > 0 && (
                  <button
                    className="bg-purple-300 text-black px-5 py-2 rounded-full hover:bg-purple-400"
                    onClick={() => {
                      setOpen(false);
                      handlePopupNow(true);
                    }}
                  >
                    Checkout
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <OrderWithCartsPopup
          cartItems={Object.keys(cartItems)
            .filter((id) => cartItems[id] > 0)
            .map((id) => {
              const product = products.find((p) => p.id === parseInt(id));
              if (!product) return null;

              const price =
                (product.old_price * (100 - product.new_price)) / 100;

              return {
                id: product.id,
                productId: product._id,
                name: product.name,
                quantity: cartItems[id],
                price: price,
                image: product.images?.[0] || "",
              };
            })
            .filter(Boolean)}
          currency={currency}
          showPopup={showPopup}
          closePopup={closePopup}
        />
      </div>
    </>
  );
};

export default Search;
